import {Trans} from '@lingui/macro';
import {createStyles, Divider, makeStyles} from '@material-ui/core';
import React from 'react';
import InstanceReadOnly from '../components/InstanceReadOnly';
const StagePage = () => {
  const classes = useStyles();
  return (
    <>
      <h2 className={classes.title}>
        <Trans>Instancias por capacitacion</Trans>
      </h2>
      <Divider variant="middle" className={classes.divider} />
      <InstanceReadOnly />
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      textAlign: 'center',
    },
    divider: {
      marginBottom: 10,
    },
  }),
);

export default StagePage;
